import { Injectable } from '@angular/core';
import { PathLocationStrategy } from '@angular/common';

@Injectable()
export class EmbeddedLocationStrategy extends PathLocationStrategy {
  override pushState(state: any, title: string, url: string, queryParams: string): void {
    this.replaceState(state, title, url, queryParams);
  }
}
